'use client'

import { ReactNode, useContext } from 'react'
import { Drawer } from '@wolfdanepug/common-react'
import { Box, Toolbar, useTheme } from '@mui/material'
import { AppContext } from '../context/app/AppContext'
import { Navigation } from './Navigation'

export const Main = ({ children }: { children: ReactNode | ReactNode[] }) => {
	const theme = useTheme()
	const { useAppState } = useContext(AppContext)
	const state: any = useAppState()

	return (
		<>
			<Drawer anchor="left" open={true} variant="permanent">
				<Toolbar sx={{ height: 110, transition: 'height 0.3s' }} />
				<Box p={3} sx={{ position: 'fixed' }}>
					<Navigation />
				</Box>
			</Drawer>
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					// padding: theme.spacing(3),
					transition: theme.transitions.create('margin', {
						easing: theme.transitions.easing.sharp,
						duration: theme.transitions.duration.leavingScreen
					}),
					// marginLeft: `-${state.leftDrawerWidth}px`,
					...(state?.leftDrawerOpen && {
						transition: theme.transitions.create('margin', {
							easing: theme.transitions.easing.easeOut,
							duration: theme.transitions.duration.enteringScreen
						}),
						marginLeft: '0'
					}),
					// marginRight: `-${state.rightDrawerWidth}px`,
					...(state?.rightDrawerOpen && {
						transition: theme.transitions.create('margin', {
							easing: theme.transitions.easing.easeOut,
							duration: theme.transitions.duration.enteringScreen
						}),
						marginRight: '0'
					}),
					...styles.main,
					[theme.breakpoints.up('md')]: {
						minHeight: 'calc(100vh - 110px)'
					}
				}}
			>
				{children}
			</Box>
		</>
	)
}

const styles = {
	main: {
		// flex: 1,
		// display: 'flex'
	},
	content: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center'
		// [theme.breakpoints.up('md')]: {
		//   justifyContent: 'flex-start'
		// }
	}
}
